export const DAY_RATE_SRT_TOKEN = 'billing_unit:day'

const DAY_RATE_SRT_TOKEN_PATTERN = new RegExp(DAY_RATE_SRT_TOKEN, 'gi')

export const isDayRateShiftType = (name?: string | null): boolean =>
  typeof name === 'string' && name.toLowerCase().includes(DAY_RATE_SRT_TOKEN)

export const stripDayRateToken = (name: string): string =>
  name.replace(DAY_RATE_SRT_TOKEN_PATTERN, ' ').replace(/\s+/g, ' ').trim()
